export const linkColorScheme = {
    RED: 'red55',
};

export enum ProviderMessagingActions {
    ACTIONS = 'actions',
    BANNER = 'banner',
}
